import convert6m2CDdhRgxpH4WjvdzxAYbGxwdGUz5MziiL5jek2kBma from './instructions/6m2CDdhRgxpH4WjvdzxAYbGxwdGUz5MziiL5jek2kBma/index'
import convert61DFfeTKM7trxYcPQCM78bJ794ddZprZpAwAnLiwTpYH from './instructions/61DFfeTKM7trxYcPQCM78bJ794ddZprZpAwAnLiwTpYH/index'
import convertATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL from './instructions/ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL/index'
import convertComputeBudget111111111111111111111111111111 from './instructions/ComputeBudget111111111111111111111111111111/index'
import convertJUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4 from './instructions/JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4/index'
import convertTokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA from './instructions/TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA/index'
import convertVote111111111111111111111111111111111111111 from './instructions/Vote111111111111111111111111111111111111111/index'
import convertwhirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc from './instructions/whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc/index'
import type { SolanaConverter } from './type'

export const convertSolanaTransactionToProgramActions: SolanaConverter = (
  args,
) => {
  const { transaction } = args

  if (!transaction.meta || !transaction.transaction.message.instructions) {
    return undefined
  }

  const programIds = transaction.transaction.message.instructions.map(
    (instruction) => instruction.programId,
  )

  // 6m2CDdhRgxpH4WjvdzxAYbGxwdGUz5MziiL5jek2kBma Program (Jupiter DEX Fill)
  if (programIds.includes('6m2CDdhRgxpH4WjvdzxAYbGxwdGUz5MziiL5jek2kBma')) {
    return convert6m2CDdhRgxpH4WjvdzxAYbGxwdGUz5MziiL5jek2kBma(args)
  }

  // 61DFfeTKM7trxYcPQCM78bJ794ddZprZpAwAnLiwTpYH Program (Jupiter DEX Fill)
  if (programIds.includes('61DFfeTKM7trxYcPQCM78bJ794ddZprZpAwAnLiwTpYH')) {
    return convert61DFfeTKM7trxYcPQCM78bJ794ddZprZpAwAnLiwTpYH(args)
  }

  // Jupiter Program
  if (programIds.includes('JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4')) {
    return convertJUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4(args)
  }

  // Whirlpool Program (Orca)
  if (programIds.includes('whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc')) {
    return convertwhirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc(args)
  }

  // Vote Program
  if (programIds.includes('Vote111111111111111111111111111111111111111')) {
    return convertVote111111111111111111111111111111111111111(args)
  }

  // AToken Program
  if (programIds.includes('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL')) {
    return convertATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL(args)
  }

  // Compute Budget Program
  if (programIds.includes('ComputeBudget111111111111111111111111111111')) {
    return convertComputeBudget111111111111111111111111111111(args)
  }

  // Token Program(一般的な処理なので、他のProgram IDに該当がない場合に処理)
  if (programIds.includes('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')) {
    return convertTokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA(args)
  }

  return undefined
}
